export default __webpack_public_path__ + "static/media/userdelete.9ae154a1.svg";